import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DeleteOutlined, EditOutlined, ReloadOutlined } from '@ant-design/icons';
import { Table, Modal, Divider, Button, Skeleton } from 'antd';
import PageTitle from '@/components/PageTitle';
import TableActionBar from '@/components/TableActionBar';
import _ from 'lodash';
import qs from 'qs';
import { checkPermission } from '@/utils/permission';
import { cleanObject, downloadFromLink, renderBooleanIcon } from '@/utils/helpers';

import { getListProcedure, getSpecificProcedure, removeProcedure } from '@/redux/actions/procedureActions';
import ProcedureForm from './ProcedureForm';
import ProcedureDetail from './ProcedureDetail';

const { confirm } = Modal;

const routes = [
    {
        path: '/',
        breadcrumbName: 'Trang chủ',
    },
    {
        path: '/procedures',
        breadcrumbName: 'Danh sách thủ thuật',
    },
]

class ProcedureList extends Component {
    state = {
        isLoading: false,
        selectedRowKeys: [],
        isOpenForm: false,
        currentItem: null,
        currentData: null,
        isOpenDetail: false
    }

    componentDidMount() {
        var query = qs.parse(this.props.location.search.slice(1));
        this.loadData(query);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.location.search !== this.props.location.search.slice()) {
            var query = qs.parse(nextProps.location.search.slice(1));
            this.loadData(query);
        }
    }

    loadData = (query) => {
        this.setState({ isLoading: true });
        this.props.getListProcedure(query).then(() => {
            this.setState({ isLoading: false });
        })
    }

    onChangeFilter(name, value) {
        var query = qs.parse(this.props.location.search.slice(1));
        query = {
            ...query,
            [name]: value
        }

        query = cleanObject(query);

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query)
        });
    }

    onChangeTable(pagination, sorter) {
        var query = qs.parse(this.props.location.search.slice(1));
        if (!_.isEmpty(pagination)) {
            query = {
                ...query,
                page: pagination.current,
                per_page: pagination.pageSize,
            }
        }
        if (!_.isEmpty(sorter)) {
            if (sorter.order) {
                query = {
                    ...query,
                    sort_field: sorter.field,
                    sort_type: sorter.order === 'ascend' ? 'ASC' : 'DESC'
                }
            } else {
                delete query.sort_field;
                delete query.sort_type;
            }
        }

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: qs.stringify(query),
        });
    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    toggleOpenForm(isOpenForm, currentItem = null) {
        this.setState({ isOpenForm: isOpenForm, currentItem: currentItem });
    }

    onEdit(id) {
        this.props.getSpecificProcedure(id).then(res => {
            console.log(res);
            this.toggleOpenForm(true, res);
        })
    }

    onRemove() {
        this.props.removeProcedure(this.state.selectedRowKeys).then(() => {
            this.setState({
                selectedRowKeys: []
            });
            setTimeout(() => {
                Modal.destroyAll();
            }, 800);
        })
    }
    openAlert(id) {
        confirm({
            title: 'Cảnh báo',
            content: 'Bạn chắc chắn muốn xoá những bản ghi này?',
            okText: 'OK',
            cancelText: 'Huỷ',
            onOk: () => this.props.removeProcedure(id).then(() => {
                setTimeout(() => {
                    Modal.destroyAll();
                }, 800);
            }),
            onCancel() { },
        })
    }

    onDetail(id) {
        this.setState({ current_id: id })
        this.props.getSpecificProcedure(id).then(res => {
            console.log(res);
            this.toggleOpenDetail(true, res);
        })
    }

    toggleOpenDetail(isOpenDetail, data = null) {
        this.setState({ isOpenDetail: isOpenDetail, currentData: data });
    }

    onDownload(url) {
        setTimeout(() => {
            const response = {
                file: url,
            };
            downloadFromLink(response.file);
        }, 100);
    }

    render() {
        var { procedureList, pagination } = this.props;
        var { isLoading, selectedRowKeys, isOpenForm, currentItem, currentData, isOpenDetail, current_id } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };
        const hasSelected = selectedRowKeys.length > 0;

        var query = qs.parse(this.props.location.search.slice(1));

        const allowCreate = checkPermission('procedures', 'create');
        const allowEdit = checkPermission('procedures', 'update');
        const allowRemove = checkPermission('procedures', 'remove');
        const allowDetail = checkPermission('procedures', 'detail');

        const columns = [
            {
                title: 'Tên thủ thuật',
                dataIndex: 'name',
                key: 'name',
                render: (text, record) => {
                    if (allowDetail) {
                        return (
                            <span
                                className="color-primary item-action-btn"
                                onClick={() => this.onDetail(record.id)}
                            >
                                {text}
                            </span>
                        );
                    }
                    return <span className="col-procedure-name">{text}</span>;
                }
            },
            {
                title: 'Đơn vị tính',
                dataIndex: ['unit', 'name'], // nếu unit là object { name: "..." }
                key: 'unit',
                align: 'center',
                width: 100,
                render: (text, record) => record?.unit?.name || '-'
            },
            {
                title: 'Thời gian thực hiện',
                dataIndex: 'execution_time',
                key: 'execution_time',
                align: 'center',
                width: 150,
                render: (text) => text ? `${text} phút` : '-'
            },
            {
                title: 'Điểm đánh giá',
                dataIndex: 'pain_score',
                key: 'pain_score',
                align: 'center',
                width: 130,
                render: (text) => text ?? '-'
            },
            {
                title: 'Trạng thái',
                dataIndex: 'status',
                key: 'status',
                align: 'center',
                width: 90,
                render: (text, record) => {
                    return (<>{renderBooleanIcon(text)}</>)
                }
            },
            {
                title: '#',
                width: '75px',
                align: 'center',
                render: (text, record) => (
                    <div>
                        {
                            allowEdit ? (
                                <>
                                    <EditOutlined className='color-primary item-action-btn' onClick={() => this.onEdit(record.id)} />
                                    <Divider type='vertical' />
                                </>
                            ) : null
                        }
                        {
                            allowRemove ? (
                                <DeleteOutlined style={{ color: 'red', cursor: 'pointer' }} onClick={() => this.openAlert([record.id])} />
                            ) : null
                        }
                    </div>
                )
            }
        ];

        return (
            <div>
                <PageTitle routes={routes} title="Danh sách thủ thuật" />
                <div>
                    <TableActionBar
                        isShowAddButton={allowCreate}
                        isShowDeleteButton={allowRemove}
                        onAdd={() => this.toggleOpenForm(true)}
                        onDelete={() => this.onRemove()}
                        disabled={!selectedRowKeys.length ? true : false}
                        showFilter={false}
                        onSearch={(value) => this.onChangeFilter('keyword', value)}
                        defaultKeyword={query.keyword}
                    >
                        <Button className="table-button" icon={<ReloadOutlined />} loading={isLoading} onClick={() => this.loadData(query)}>Refresh</Button>
                        {
                            hasSelected ? <span>Đang chọn {selectedRowKeys.length} bản ghi</span> : ''
                        }
                    </TableActionBar>
                </div>
                {
                    procedureList && procedureList.length ? (
                        <Table
                            rowKey="id"
                            size="small"
                            dataSource={procedureList ?? []}
                            columns={columns}
                            loading={isLoading}
                            rowSelection={rowSelection}
                            defaultExpandAllRows={true}
                            pagination={{
                                pageSize: pagination.perPage,
                                current: pagination.currentPage,
                                total: pagination.total,
                                showTotal: total => `Tổng ${total} bản ghi`
                            }}
                            onChange={(pagination, filters, sorter) => this.onChangeTable(pagination, sorter)}
                            scroll={{
                                x: 'max-content'
                            }}
                        />
                    ) : (
                        <Skeleton active />
                    )
                }

                <ProcedureForm
                    visible={isOpenForm}
                    currentItem={currentItem}
                    reloadData={() => this.loadData(query)}
                    onCancel={() => this.toggleOpenForm(false)}
                />
                <ProcedureDetail
                    visible={isOpenDetail}
                    currentItem={currentData}
                    reloadData={() => {
                        this.onDetail(current_id);
                        this.loadData(query);
                    }}
                    onCancel={() => this.toggleOpenDetail(false)}
                />
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        procedureList: state.procedureReducer.procedureList,
        pagination: state.procedureReducer.pagination,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getListProcedure: (filter) => dispatch(getListProcedure(filter)),
        getSpecificProcedure: (id) => dispatch(getSpecificProcedure(id)),
        removeProcedure: (ids) => dispatch(removeProcedure(ids))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcedureList);
